<div class="palantir-pagination">
  <div class="palantir-pagination__items-per-page">
    <palantir-text type="description" size="xs">{{ perPageLabel }}</palantir-text>

    <div class="palantir-pagination__items-per-page-button" [cdkMenuTriggerFor]="menu">
      <palantir-text type="description" size="xs">{{ service.take() }}</palantir-text>

      <palantir-icon name="arrow-drop-down-outline" />
    </div>

    <ng-template #menu>
      <palantir-content class="palantir-menu" cdkMenu layout="no-padding">
        @for (option of paginationOptions(); track option) {
          <palantir-button
            theme="transparent"
            size="xs"
            [attr.variant]="option === service.take() ? 'positive' : 'neutral'"
            (click)="changePaginationSize(option)"
          >
            {{ option }}
          </palantir-button>
        }
      </palantir-content>
    </ng-template>
  </div>

  <div class="palantir-pagination__navigation">
    <palantir-button
      layout="icon"
      theme="outline"
      [attr.disabled]="
        !service.pageInfo().previousNode || service.isLoading() || service.isSearching?.()
      "
      icon="first-page-outline"
      (click)="firstPage()"
    />

    <palantir-button
      layout="icon"
      theme="outline"
      [attr.disabled]="
        !service.pageInfo().previousNode || service.isLoading() || service.isSearching?.()
      "
      icon="chevron-left-outline"
      (click)="previousPage()"
    />

    <palantir-button
      layout="icon"
      theme="outline"
      [attr.disabled]="
        !service.pageInfo().nextNode || service.isLoading() || service.isSearching?.()
      "
      icon="chevron-right-outline"
      (click)="nextPage()"
    />
  </div>
</div>
